<template>
  <section id="discount_container">
    <Styles>
      <div class="columns">
        <div class="column">
          <CompanySelector v-model="company" v-validate="'required'" placeholder="Seleccione una empresa"
                           name="company"/>
          <span class="show-error">{{ errors.first("company") }}</span>
        </div>
        <div class="column">
          <b-field label="Formato">
            <b-select
                placeholder="Seleccione una forma"
                expanded
                v-model="format"
                v-validate="'required'"
                name="type"
                :disabled="!company"
            >
              <option
                  v-for="option in formats"
                  :value="option.id"
                  :key="option.id"
                  :id="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column"></div>
      </div>
      <div class="columns" v-if="format === 'F' || format === 'R'">
        <div class="column">
          <InvoiceCode
              v-bind:mask="mask"
              v-bind:maskList="maskList"
              @updateMask="updateMask"
              @setMask="setMask"
          />
        </div>
      </div>
      <div class="columns" v-if="selectedMask && format === 'F'">
        <div class="column">
          <Ranges
              v-bind:discountTypes="types"
              v-bind:discountsList="tableData"
              v-bind:mask="selectedMask"
              v-bind:ranges="selectedMask.ranges ? selectedMask.ranges : []"
              @updateRangeList="updateRangeList"
          />
          <vs-button
              color="primary"
              type="filled"
              icon="save"
              @click="saveMasks()"
          >
            Guardar
          </vs-button>
        </div>
      </div>
      <div class="columns">
        <div class="column" v-if="format === 'L'">
          <DiscountsLoader/>
        </div>
      </div>
      <div v-if="format === 'N'">
        <div class="columns">
          <div class="column">
            <b-field label="Código">
              <b-input
                  placeholder="Ingrese un código..."
                  type="text"
                  v-model="code"
                  name="code"
                  v-validate="'required|numeric|max_value:255'"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("code") }}</span>
          </div>
          <div class="column">
            <b-field label="Nombre">
              <b-input
                  placeholder="Ingrese un nombre..."
                  type="text"
                  v-model="name"
                  name="name"
                  v-validate="'required'"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("name") }}</span>
          </div>
          <div class="column">
            <b-field label="Dirección">
              <b-input
                  placeholder="Ingrese una dirección..."
                  type="text"
                  v-model="address"
                  name="address"
              ></b-input>
            </b-field>
            <!--<span class="show-error">{{ errors.first("company") }}</span>-->
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Teléfono">
              <b-input
                  placeholder="Ingrese un número de teléfono..."
                  type="text"
                  v-mask="'##############'"
                  v-model="phone"
                  name="phone"
              ></b-input>
            </b-field>
            <!--<span class="show-error">{{ errors.first("company") }}</span>-->
          </div>
          <div class="column">
            <b-field label="Responsable">
              <b-input
                  placeholder="Responsable..."
                  type="text"
                  v-model="manager"
                  name="manager"
              ></b-input>
            </b-field>
            <!--<span class="show-error">{{ errors.first("company") }}</span>-->
          </div>
          <div class="column">
            <b-field label="Tipo">
              <b-select
                  placeholder="Seleccione un tipo"
                  expanded
                  v-model="type"
                  name="type"
              >
                <option
                    v-for="option in types"
                    :value="option.id"
                    :key="option.id"
                    :id="option.id"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <span class="show-error">{{ errors.first("type") }}</span>
          </div>
        </div>
        <div class="columns">
          <div class="column" v-if="type !== 'T' && type !== 'M'">
            <b-field :label="getValueTypeLabel().label">
              <b-input
                  :placeholder="getValueTypeLabel().placeholder"
                  :type="getValueTypeLabel().type || 'text'"
                  v-model="value"
                  v-validate="'required'"
                  v-mask="getValueTypeLabel().mask"
                  name="value"
                  @chage="validatePercentage()"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("value") }}</span>
            <span class="show-error" v-if="!validatePercentage()">El porcentaje debe ser un valor entre 0 y 100</span>
          </div>
          <div class="column" v-if="type === 'T' || type === 'M'">
            <TimeSelector label="Tiempo *" v-model="value"/>
            <span class="show-error">{{
                timeError ? "Es obligatorio" : ""
              }}</span>
          </div>
          <div class="column">
            <b-field label="Cantidad de veces">
              <b-input
                  placeholder="Ingrese un valor..."
                  type="number"
                  v-model="repeat"
                  v-validate="'numeric|min_value:0'"
                  name="repeat"
              ></b-input>
            </b-field>
            <span class="show-error">{{ errors.first("repeat") }}</span>
          </div>
          <div class="column" v-if="type !== 'T'"></div>
          <div class="column mt-button pt-3" v-if="type == 'T'">
            <b-checkbox v-model="useRealValue" true-value="Y" false-value="N">
              Usar valor real
            </b-checkbox>
          </div>
        </div>


        <div class="columns">
          <div class="column">
            <b-field label="Fecha inicial">
              <b-datepicker
                  v-model="initialDate"
                  placeholder="Seleccione una fecha..."
                  icon="calendar-today"
                  name="date1"
              >
              </b-datepicker>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Fecha final">
              <b-datepicker
                  v-model="finalDate"
                  placeholder="Seleccione una fecha..."
                  icon="calendar-today"
                  name="date2"
              >
              </b-datepicker>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Tipo de uso">

              <treeselect
                  placeholder="Seleccione tipo de uso"
                  expanded
                  :options="typesUse"
                  v-model="duration"
                  name="typeUse"
              />
            </b-field>
            <span class="show-error">{{ errors.first("duration") }}</span>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Tipo de liquidación en línea">
              <div class="d-flex">
                <div class="column">
                  <vs-radio v-model="liqType" vs-name="decision-action" vs-value="MANUAL">Manual - (seleccionable desde
                    el módulo)
                  </vs-radio>
                </div>
                <div class="column">
                  <vs-radio v-model="liqType" vs-name="decision-action" vs-value="RANGE">Automática - (por rango de las
                    facturas)
                  </vs-radio>
                </div>
                <div class="column">
                </div>
              </div>
            </b-field>
          </div>
        </div>
        <vs-row vs-justify="center" v-if="liqType==='RANGE'">
          <vs-col type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-xs="12"
                  vs-sm="12">
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-card style="border-radius: 10px;">
              <div slot="header">
                <h3 class="card-title mb-0">Asignación de rangos del descuento</h3>
                <vs-button icon="add" color="primary" class="flex-shrink-0 ml-auto" @click="addRange()">
                  Añadir rango
                </vs-button>
              </div>
              <vs-table max-items="6" pagination :data="filteredRanges">
                <template slot="header"></template>
                <template slot="thead">
                  <vs-th>Rango inicial</vs-th>
                  <vs-th>Rango final</vs-th>
                  <vs-th>Tipo</vs-th>
                  <vs-th>Valor</vs-th>
                  <vs-th>Acciones</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data ">
                    <vs-td :data="data[indextr].initialValue">
                      <b-field>
                        <b-input placeholder="Ingrese un valor..."
                                 type="Number"
                                 v-model="data[indextr].initialValue"
                                 :max="999999999999"></b-input
                        >
                      </b-field>
                    </vs-td>
                    <vs-td :data="data[indextr].finalValue">
                      <b-field>
                        <b-input placeholder="Ingrese un valor..." type="Number"
                                 v-model="data[indextr].finalValue"
                                 :max="999999999999"></b-input>
                      </b-field>
                    </vs-td>

                    <vs-td :data="data[indextr].rangeClassification">
                      <b-field>
                        <b-select
                            placeholder="Seleccione un tipo"
                            expanded
                            v-model="data[indextr].rangeClassification"
                        >
                          <option
                              v-for="option in types"
                              :value="option.id"
                              :key="option.id"
                              :id="option.id"
                          >
                            {{ option.name }}
                          </option>
                        </b-select>
                      </b-field>
                    </vs-td>

                    <vs-td :data="data[indextr].amount">
                      <div
                          v-if="data[indextr].rangeClassification !== 'T' && data[indextr].rangeClassification !== 'M'">
                        <b-field>
                          <b-input
                              :placeholder="getValueTypeRange(data[indextr].rangeClassification).placeholder"
                              :type="getValueTypeRange(data[indextr].rangeClassification).type || 'text'"
                              v-model="data[indextr].amount"
                              name="value"
                          ></b-input>
                        </b-field>
                      </div>
                      <div
                          v-if="data[indextr].rangeClassification === 'T' || data[indextr].rangeClassification === 'M'">
                        <TimeSelector class="rangeTime-input" v-model="data[indextr].amount"/>
                      </div>
                    </vs-td>
                    <vs-td :data="data[indextr]">
                      <b-field>
                        <b-button type="is-danger" title="Eliminar"
                                  @click="deleteRange(data[indextr], indextr)"
                                  icon-right="delete"/>
                      </b-field>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-card>
          </vs-col>
        </vs-row>
        <div class="columns">
          <div class="column">
            <div class="vehicle-types-content">
              <div class="vehicle-types-header">
                <div class="col">Tipo vehículo</div>
                <div class="col">Tarifa</div>
              </div>
              <div class="vehicle-types-body">
                <div
                    class="item"
                    v-for="(item, index) in vehicles"
                    :key="item.code"
                    :id="index"
                >
                  <div class="col vt-title">
                    <vs-checkbox v-model="item.selected">{{
                        item.title
                      }}
                    </vs-checkbox>
                  </div>
                  <div class="col">
                    <b-select
                        placeholder="Seleccione una tarifa"
                        expanded
                        v-model="item.tariff"
                    >
                      <option
                          v-for="option in rates"
                          :value="option.code"
                          :key="option.code"
                          :id="option.code"
                      >
                        {{ option.title }}
                      </option>
                    </b-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column ml-3">
            <div class="block">
              <b-checkbox v-model="blocked" true-value="Y" false-value="N">
                Bloqueado
              </b-checkbox>
            </div>
            <div class="block">
              <b-checkbox v-model="sum" true-value="Y" false-value="N">
                Sumar facturas
              </b-checkbox>
            </div>
            <div class="block">
              <b-checkbox
                  v-model="notAccessible"
                  true-value="Y"
                  false-value="N"
              >
                Accesible por cajero
              </b-checkbox>
            </div>
            <div class="block">
              <b-checkbox
                  v-model="requiresAuth"
                  true-value="Y"
                  false-value="N">
                Requiere autorización
              </b-checkbox>
            </div>
          </div>
        </div>

        <div class="buttons button-group">
          <b-button
              @click="save()"
              title="Guardar cambios"
              icon-left="content-save"
              type="is-info"
          >
            Guardar cambios
          </b-button>
          <b-button
              @click="cleanForm()"
              icon-left="backspace"
              v-if="id != null"
              type="is-dark"
              title="Limpiar"
          >Limpiar
          </b-button>
          <b-button
              @click="openDeleteModal()"
              v-if="id != null"
              type="is-danger"
              title="Eliminar"
              icon-left="delete"
          >Eliminar
          </b-button>
        </div>
        <div class="columns">
          <div class="column">
            <b-table :data="tableData" :selected.sync="selected" focusable>
              <b-table-column field="company" label="Empresa" v-slot="props">
                {{ props.row.company.name }}
              </b-table-column>
              <b-table-column field="company" label="Code" v-slot="props">
                {{ props.row.uuid }}
              </b-table-column>
              <b-table-column field="title" label="Nombre" v-slot="props">
                {{ props.row.title }}
              </b-table-column>
              <b-table-column
                  field="company"
                  label="Tipo de vehículo"
                  v-slot="props"
              >
                {{ props.row.vehicleTypes.length }} seleccionados
              </b-table-column>

              <b-table-column field="date" label="Valor" v-slot="props">
                {{ props.row.amount }}
              </b-table-column>
              <template #bottom-left></template>
              <template #empty>
                <div class="has-text-centered">Sin registros</div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </Styles>
  </section>
</template>
<style>
.rangeTime-input {
  width: 30em;
  z-index: 75;
  display: flex;
}
</style>
<script>
import moment from "moment";
import {ROUTES} from "@/global/api_routes";
import TimeSelector from "../../components/Shared/TimeSelector";
import {confirmation} from "@/global/utils";
import InvoiceCode from "./InvoiceCode/index.vue";
import Ranges from "./Ranges";
import RangesCode from "./Ranges/Code.vue";
import DiscountsLoader from "./Loader";
import Styles from "./styles";
import toast from "@/global/ToastConfig";
import {configToast, TOAST_TYPES} from "@/global/toast";
import {get as getProp} from "object-path";
import CompanySelector from "../../components/Shared/CompanySelector";

export default {
  name: "Discount",
  components: {
    Styles,
    InvoiceCode,
    Ranges,
    RangesCode,
    DiscountsLoader,
    TimeSelector,
    CompanySelector
  },
  data: () => ({
    selectedMask: null,
    timeError: false,
    code: null,
    name: null,
    address: null,
    phone: null,
    manager: null,
    type: null,
    value: 0,
    rate: null,
    id: null,
    vehicle: null,
    repeat: null,
    useRealValue: null,
    blocked: "N",
    sum: "N",
    notAccessible: "N",
    requiresAuth: "N",
    initialDate: null,
    finalDate: null,
    company: null,
    duration: "F",
    mask: null,
    isLoading: false,
    format: "N",
    formats: [
      {name: "Normal", id: "N"},
      {name: "Código Factura", id: "F"},
      {name: "Cargue masivo", id: "L"},
    ],
    types: [
      {
        name: "Tiempo",
        id: "T",
        mask: "##:##",
        type: "time",
        label: "Tiempo (minutos) *",
        placeholder: "Ejemplo 00:15",
      },
      {
        name: "Efectivo",
        id: "C",
        mask: "########",
        label: "Valor efectivo *",
        placeholder: "Valor efectivo",
      },
      {
        name: "Porcentaje",
        id: "P",
        mask: "###",
        label: "Valor Porcentaje *",
        placeholder: "Valor porcentaje (10)%",
      },
      {
        name: "Trasladar tiempo",
        id: "M",
        mask: "##:##",
        label: "Tiempo (minutos) *",
        placeholder: "Ejemplo 00:15",
      },
    ],
    durations: [
      {name: "Abierto", id: "F"},
      {name: "Una Vez", id: "O"},
    ],
    vehicles: [],
    rates: [],
    companies: [],
    tableData: [],
    tableLoading: false,
    selected: null,
    maskList: [],
    typeUse: null,
    typesUse: [
      {
        label: "Siempre",
        id: "F"
      }, {
        label: "Ocasional",
        id: "O"
      }],
    liqType: "MANUAL",
    listRange: []
  }),
  mounted() {
    this.isLoading = true;
    this.getVehicleTypes();
  },
  computed: {
    filteredRanges() {
      // Filtrar elementos cuyo status no sea 'D'
      return this.listRange.filter(range => range.status !== 'D');
    }
  },
  watch: {
    format() {
      this.getMaskDiscounts();
    },
    company() {
      this.getMaskDiscounts();
      if (typeof this.company != "undefined" && this.company != null) {
        this.cleanForm();
        this.isLoading = true;
        this.getRates();
        this.getDiscounts();
        return;
      }
      this.cleanForm();
    },
    selected(value) {
      if (this.selected != null) {
        this.fillData(value);
      }
    }
  },
  methods: {
    testClick() {
      this.value = this.value + 1;
    },
    getMaskDiscounts() {
      if (this.format == "F") {
        this.maskList = [];
        this.getListMasks();
      }
    },
    getValueTypeLabel() {
      const typeSelection = this.types.find((item) => item.id === this.type);
      if (!typeSelection) {
        return {
          label: "Valor",
          mask: "########",
          placeholder: "Ingrese un valor...",
        };
      }
      return typeSelection;
    },
    getValueTypeRange(typeRange) {
      const typeSelection = this.types.find((item) => item.id === typeRange);
      if (!typeSelection) {
        return {
          label: "Valor",
          mask: "########",
          placeholder: "Ingrese un valor...",
        };
      }
      return typeSelection;
    },
    updateRangeList(range) {
      const list = Array.isArray(this.selectedMask.ranges)
          ? [...this.selectedMask.ranges]
          : [];
      if (range.delete) {
        const finalList = list.map((item) => ({
          ...item,
          delete: item.delete || item.index == range.index,
        }));
        this.selectedMask.ranges = finalList;
        this.$forceUpdate();
        return;
      }
      const indexExists = list.findIndex((item) => item.index === range.index);
      if (indexExists < 0) {
        list.push(range);
      } else {
        list[indexExists] = range;
      }
      this.selectedMask.ranges = list;
    },
    setMask(mask) {
      this.selectedMask = mask;
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#discount_container");
      return instance.open(message, type);
    },
    getListMasks() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.DISCOUNTS.GET_MASKS_RANGES, {
            params: {
              company: this.company,
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              const list = data.info.map((item) => {
                const sections = JSON.parse(item.sections);
                const section = sections.find((s) => s.primary);
                return {
                  code: item.code,
                  index: item.code,
                  mask: item.description,
                  section: section ? section.code : undefined,
                  ranges: item.voucherRanges.map((v) => {
                    return {
                      discount: v.voucher,
                      index: v.code,
                      code: v.code,
                      initRange: v.initialValue,
                      finalRange: v.finalValue,
                    };
                  }),
                  maskDetails: sections.map((section) => {
                    return {
                      code: section.code,
                      index: section.code,
                      label: section.label,
                      mask: section.mask,
                      primary: section.primary,
                      num: section.digits,
                    };
                  }),
                };
              });
              this.maskList = list;
              return;
            }
            this.toast("No hay registros", TOAST_TYPES.ERROR);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    removeMaskItem(mask) {
      const list = [...this.maskList];
      if (mask.delete && mask.code) {
        this.maskList = list.map((item) => ({
          ...item,
          delete: item.delete || mask.index == item.index,
        }));
        return true;
      }
      if (mask.delete) {
        this.maskList = list.filter((item) => item.index != mask.index);
        return true;
      }
      this.selectedMask = null;
      this.selected = null;
      return false;
    },
    updateMask(mask) {
      this.selectedMask = null;
      const list = [...this.maskList];
      if (this.removeMaskItem(mask)) {
        return;
      }
      const indexExists = list.findIndex((item) => item.index === mask.index);
      if (indexExists < 0) {
        list.push(mask);
      } else {
        list[indexExists] = mask;
      }
      this.maskList = list;
    },
    openDeleteModal() {
      confirmation(this, `¿Desea eliminar el descuento?`).then((result) => {
        if (!result) {
          return;
        }
        this.deleteCompany();
      });
    },
    deleteCompany() {
      this.isLoading = true;
      try {
        this.$http
            .delete(ROUTES.DASHBOARD.DISCOUNTS.DELETE_DISCOUNT, {
              voucherId: this.id,
            })
            .then(({data}) => {
              this.isLoading = false;
              if (data.code > 0) {
                this.toast(data.message, TOAST_TYPES.SUCCESS);
                this.getDiscounts();
                this.cleanForm();
                return;
              }
              this.isLoading = false;
              this.toast(data.message, TOAST_TYPES.ERROR);
            });
      } catch (error) {
        this.isLoading = false;
      }
    },
    getNormalDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    fillData(selected) {

      if (!selected) {
        return;
      }
      this.id = selected.code;
      this.name = selected.title;
      this.phone = selected.telephone;
      this.company = selected.company.code;
      this.manager = selected.manager;
      this.address = selected.address;
      this.blocked = selected.blocked;
      this.initialDate =
          selected.initialDate != null
              ? moment(selected.initialDate).toDate()
              : null;
      this.finalDate =
          selected.finalDate != null ? moment(selected.finalDate).toDate() : null;
      const isTime =
          selected.classification == "T" || selected.classification == "T";
      this.value = selected.amount;
      this.finalValue = selected.finalValue;
      this.currentValue = selected.currentValue;
      this.useRealValue = selected.useRealValue;
      this.notAccessible = selected.cashier;
      this.code = selected.uuid;
      this.repeat = selected.repeat;
      this.duration = selected.type;
      this.liqType = selected.liquidationType;
      this.listRange = selected.voucherRanges
      this.rate =
          selected.tariff == null ? null : getProp(selected, "tariff.code");
      this.type = selected.classification;
      this.requiresAuth = (!selected.permission) ? "N" : selected.permission;
      this.sum =
          selected.sumInvoice == "N" || selected.sumInvoice == null ? "N" : "Y";
      this.vehicles = this.vehicles.map(vehicleType => {
        const found = selected.vehicleTypes.find(select => select.vehicleType === vehicleType.code);
        vehicleType.selected = !!found;
        vehicleType.tariff = found && found.tariffCode ? found.tariffCode : null;
        return vehicleType;
      });
    },
    getRates() {
      if (!this.company) {
        return;
      }
      this.rates = [];
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.RATES.GET_RATES, {
            params: {
              companyId: this.company,
            },
          })
          .then(({data}) => {
            if (data.code <= 0) {
              this.toast("No has creado tarifas", TOAST_TYPES.ERROR);
              return;
            }
            this.rates = data.info;
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    getVehicleTypes() {
      this.$http.get(ROUTES.DASHBOARD.GET_VEHICLE_TYPES).then(({data}) => {
        if (data.code <= 0) {
          this.toast(data.message, TOAST_TYPES.ERROR);
          return;
        }
        this.vehicles = data.info;
        this.toast(data.message, TOAST_TYPES.SUCCESS);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getDiscounts() {
      this.isLoading = true;
      const company = this.company;
      this.$http
          .get(ROUTES.DASHBOARD.DISCOUNTS.GET_DISCOUNT_TYPE_DEVICE, {
            params: {
              companyId: company,
            },
          })
          .then(({data}) => {
            if (data.code <= 0) {
              this.tableData = [];
              return;
            }
            this.tableData = data.info.map((item) => ({
              ...item,
              vehicleTypes: !item.vehicleTypes
                  ? []
                  : JSON.parse(item.vehicleTypes),
            }));
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    validateVehicleTypes() {
      const vehicleTypesSelections = this.vehicles.filter(
          (item) => item.selected && item.tariff
      );
      if (vehicleTypesSelections.length == 0) {
        this.toast(
            "Debes seleccionar al menos un tipo de vehículo y su respectiva tarifa",
            TOAST_TYPES.ERROR
        );
        return false;
      }

      return true;
    },
    getDiscountObject() {
      const vehicleTypes = this.vehicles
          .filter((item) => item.selected)
          .map((item) => ({vehicleType: item.code, tariffCode: item.tariff}));
      const isTime = this.type == "T" || this.type == "M";
      const send = {
        code: this.id,
        uuid: this.code,
        initialDate:
            this.initialDate != null
                ? this.getNormalDate(this.initialDate)
                : null,
        finalDate:
            this.finalDate != null ? this.getNormalDate(this.finalDate) : null,
        amount: this.value,
        classification: this.type,
        address: this.address,
        title: this.name,
        type: this.duration,
        permission: this.requiresAuth,
        cashier: this.notAccessible,
        sumInvoice: this.sum,
        manager: this.manager,
        blocked: this.blocked,
        telephone: this.phone,
        repeat: this.repeat,
        useRealValue: this.useRealValue,
        company: {
          code: this.company,
        },
        vehicleTypes: JSON.stringify(vehicleTypes),
        typeDevice: 'GASTONWEB',
        liquidationType: this.liqType,
        voucherRanges: this.listRange
      };
      if (send.code === null) {
        delete send.code;
      }
      return send;
    },
    save() {
      this.$validator.validateAll().then((result) => {
        this.timeError = !this.value;
        if (!result || !this.validatePercentage()) {
          this.toast('No se pudo guardar el descuento. Revisa el formulario', TOAST_TYPES.ERROR);
          this.isLoading = false;
          return;
        }
        this.isLoading = true;
        const send = this.getDiscountObject();
        try {
          this.validateRangeList(send.voucherRanges);
          this.$http
              .post(ROUTES.DASHBOARD.DISCOUNTS.SAVE_DISCOUNT, send)
              .then(({data}) => {
                if (data.code <= 0) {
                  this.toast(data.message, TOAST_TYPES.ERROR);
                  this.isLoading = false;
                  return;
                }
                this.toast(data.message + ", \n Se ha guardado el descuento", TOAST_TYPES.SUCCESS);
                this.isLoading = false;
                this.cleanForm();
                this.getDiscounts();
                this.getRates();
              });
        } catch (error) {
          toast.error(error.message)
          this.isLoading = false;
        }
      });
    },
    getMaskObject() {
      return this.maskList.map((item) => {
        return {
          code: item.code,
          description: item.mask,
          company: {code: this.company},
          deleted: item.delete,
          sections: JSON.stringify(
              item.maskDetails.map((md, index) => ({
                code: md.code,
                label: md.label,
                mask: md.mask,
                digits: md.num,
                primary: md.index == item.section,
                maskComplete: new Array(md.num).fill(md.mask).join(""),
              }))
          ),
          voucherRanges: item.ranges.map((r) => ({
            code: r.code,
            voucher: {code: r.discount.code},
            initialValue: parseInt(r.initRange),
            finalValue: parseInt(r.finalRange),
            deleted: r.delete,
          })),
        };
      });
    },
    saveMasks() {
      const obj = this.getMaskObject();
      this.isLoading = true;
      this.$http
          .post(ROUTES.DASHBOARD.DISCOUNTS.SAVE_MASK_DISCOUNT, obj)
          .then(({data}) => {
            if (data.code > 0) {
              this.toast(data.message, TOAST_TYPES.SUCCESS);
              this.getListMasks();
              return;
            }
            this.toast(data.message, TOAST_TYPES.ERROR);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    cleanForm() {
      this.code = null;
      this.name = null;
      this.address = null;
      this.phone = null;
      this.manager = null;
      this.type = null;
      this.value = null;
      this.id = null;
      this.rate = null;
      this.vehicle = "N";
      this.blocked = "N";
      this.sum = "N";
      this.repeat = null;
      this.notAccessible = "N";
      this.requiresAuth = "N";
      this.initialDate = null;
      this.finalDate = null;
      this.company = this.company;
      this.selected = null;
      this.duration = null;
      this.vehicle = null;
      this.isLoading = false;
      this.rates = [];
      this.useRealValue = "N";
      this.selectedMask = null;
      this.duration = "F";
      this.liqType = "MANUAL",
          this.listRange = [],
          this.mask = null;
      this.tableLoading = false;
      this.format = "N";
      this.vehicles = this.vehicles.map((item) => ({
        ...item,
        selected: false,
        tariff: null,
      }));
      this.getRates();
      this.getDiscounts();
    },
    validatePercentage() {
      if (this.type === 'P') {
        return this.value <= 100;
      }
      return true;
    },
    /**
     *
     */
    addRange() {
      const tempData = [
        ...this.listRange,
        {
          initialValue: null,
          finalValue: null,
          rangeClassification: null,
          amount: null,
          code: null,
          status: null
        },
      ];
      this.listRange = tempData;
    },
    /**
     *
     * @param range
     */
    deleteRange(range, indexRange) {
      confirmation(this, `¿Deseas eliminar el rango?`).then(
          (result) => {
            if (!result) {
              return;
            }
            if (range.code !== null) {
              range.status = 'D';
              return;
            }
            this.listRange.splice(indexRange, 1)
          });
    },
    /**
     * Validacion del formulario de rangos
     * @param listRanges lista de rangos
     */
    validateRangeList(listRanges) {
      console.log(listRanges, "lista de rangos a validar")
      if (this.liqType === 'RANGE') {
        if (listRanges.length === 0) {
          throw new Error("Debe agregar al menos un rango  para la liquidación automática por rango de facturas");
        }
        const active = this.filteredRanges.length > 0;
        if (!active) {
          throw new Error("Debe agregar al menos un rango  para la liquidación automática por rango de facturas");
        }
        const percentageOutRange = this.checkPercentage(this.filteredRanges);
        if (percentageOutRange) {
          throw new Error("El valor del porcentage no puede ser mayor a 100")
        }
        const validate = this.validateRangeForm(this.filteredRanges);

        if (validate === true) throw new Error("Hay campos pendientes por ingresar en los rangos");
        const wrongValues = this.checkValues(this.filteredRanges)
        if (wrongValues) {
          console.log(wrongValues)
          throw new Error("Revise los valores inicial y final de los rangos");
        }
        const rangesOverlap = this.checkRanges(this.filteredRanges);
        if (rangesOverlap) {
          throw new Error("Error: Los valores de los rangos se superponen")
        }
      }
    },
    checkPercentage(listRange) {
      let found = 0;
      listRange.forEach(range => {
        if (range.rangeClassification === 'P' && range.amount > 100) {
          found++;
        }
      });
      return found > 0;
    },
    validateRangeForm(listRange) {
      let found = 0;
      listRange.forEach(range => {
        if (range.initialValue == null || range.finalValue == null) {
          found++;
        }
        if (range.rangeClassification == null
            || range.amount == null
            || range.rangeClassification === ""
            || range.amount === "") {
          found++;
        }
      });
      return found > 0;
    },
    checkValues(listRange) {
      let found = 0;
      listRange.forEach(range => {
        let initial = Number(range.initialValue)
        let final = Number(range.finalValue)
        if (final < initial) found++
        if (initial > final) found++
      })
      return found > 0;
    },
    /**
     * Verifica que los valores de los Rangos no se superpongan
     * @param listRange
     * @returns {boolean}
     */
    checkRanges(listRange) {
      for (const range of listRange) {
        range.initialValue = Number(range.initialValue);
        range.finalValue = Number(range.finalValue);
      }
      if (listRange.length < 2) return false;
      listRange.sort((a, b) => a.initialValue - b.initialValue);
      for (let i = 0; i < listRange.length - 1; i++) {
        const currentInitial = listRange[i].initialValue;
        const currentFinal = listRange[i].finalValue;
        for (let j = i + 1; j < listRange.length; j++) {
          const nextInitial = listRange[j].initialValue;
          const nextFinal = listRange[j].finalValue;
          if (nextInitial > currentFinal) break;
          if ((currentInitial <= nextFinal && currentFinal >= nextInitial) ||
              (nextInitial <= currentFinal && nextFinal >= currentInitial)) {
            return true;
          }
        }
      }
      return false;
    }
  },
};
</script>
